import { render } from "./RowBarChart.vue?vue&type=template&id=506ee315&scoped=true"
import script from "./RowBarChart.vue?vue&type=script&lang=js"
export * from "./RowBarChart.vue?vue&type=script&lang=js"

import "./RowBarChart.vue?vue&type=style&index=0&id=506ee315&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506ee315"]])

export default __exports__